import { render, staticRenderFns } from "./touch-switch.vue?vue&type=template&id=dbe0a0ee&scoped=true&lang=pug"
import script from "./touch-switch.vue?vue&type=script&lang=js"
export * from "./touch-switch.vue?vue&type=script&lang=js"
import style0 from "./touch-switch.vue?vue&type=style&index=0&id=dbe0a0ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe0a0ee",
  null
  
)

export default component.exports